import { SupplierGetResponseType } from "@sellar-io/api-v2/types";
import { formatCurrency } from "@sellar-io/common";
import { BadgeIndigo } from "../../../../../../../components/badge/Badge";
import { ProgressBarIndigo } from "../../../../../../../components/progressBar/ProgressBar";
import { Icon } from "../../../../../../../components";

export function MinimumOrderPriceProgress({
  minimumOrderPrice,
  price,
  currency,
  onClick,
}: {
  minimumOrderPrice: number;
  price?: number;
  currency: SupplierGetResponseType["currency"];
  onClick: () => void;
}) {
  const percentage = !price ? 0 : (price / minimumOrderPrice) * 100;

  if (!price) {
    return (
      <>
        {`Minimum order total of ${formatCurrency(
          minimumOrderPrice,
          currency,
        )}`}
      </>
    );
  }

  if (price >= minimumOrderPrice) {
    return null;
  }

  return (
    <div
      className="grid cursor-pointer grid-cols-5 items-center gap-2 rounded-lg border border-solid border-indigo-300 bg-indigo-100 p-2"
      onClick={onClick}
    >
      <div className="col-span-5 flex items-center gap-2 md:col-span-3">
        <BadgeIndigo icon={"CLIPBOARD_CHECK_OUTLINE"} />
        <div className={"text-indigo-800"}>
          Spend{" "}
          <strong>
            {formatCurrency(minimumOrderPrice - price, currency)} more
          </strong>{" "}
          to meet minimum order total
        </div>
      </div>

      <div className="col-span-5 flex items-center gap-2 md:col-span-2">
        <ProgressBarIndigo percentage={percentage} className="bg-indigo-200" />
        <Icon icon={"CHEVRON_RIGHT"} size={1} />
      </div>
    </div>
  );
}
